// src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import { ConfigProvider, App } from 'antd';
import MessageProvider from './components/MessageProvider';
import routes from './router/routes';
import './index.css';
import 'antd/dist/reset.css';
import 'virtual:svg-icons-register';
import './assets/styles/variables.scss';

function AppRouter() {
  // 根据配置直接渲染整棵路由树
  return useRoutes(routes);
}

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
  <ConfigProvider>
    <App>
      <MessageProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </MessageProvider>
    </App>
  </ConfigProvider>
  // </React.StrictMode>
);
